import { filter, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { bootstrapAction } from '../extensions';
import { setDeviceVersionOnRootElements } from '../../deviceVersion';
import { setShadowRootStyling } from '../../utils/shadowRootStyling';
import cast from '../../types/chromecast-caf-receiver/index';
import { observeOnMutation } from '../../utils/observeOnMutation';

export class StylingPlugin {
  init() {
    bootstrapAction.register(async context => {
      setDeviceVersionOnRootElements();
      await setShadowRootStyling(document.getElementById('castPlayer'));
      const playerManager = context.getPlayerManager();
      // Disable counters and titles while commercials
      playerManager.addEventListener(cast.framework.events.EventType.MEDIA_STATUS, () => {
        const touchControlsShadowRoot =
          document.getElementsByTagName('touch-controls')[0]?.shadowRoot;
        if (touchControlsShadowRoot) {
          const breakTitle = touchControlsShadowRoot.getElementById('break-title');
          if (breakTitle) breakTitle.style.display = 'none';

          const breakCountdown = touchControlsShadowRoot.getElementById('break-countdown');
          if (breakCountdown) breakCountdown.style.display = 'none';
        } else {
          const breakInfo = document
            .getElementsByTagName('cast-media-player')[0]
            ?.shadowRoot?.children[1]?.getElementsByClassName('breakInfo')[0];
          if (breakInfo) (breakInfo as HTMLElement).style.display = 'none';
        }
      });
      const config = { attributes: false, childList: true, characterData: false };

      observeOnMutation(document.body, config)
        .pipe(
          mergeMap(mutations => of(...mutations)),
          mergeMap(mutation => of(...mutation.addedNodes)),
          filter(node => node.nodeName === 'TOUCH-CONTROLS')
        )
        .subscribe(n => setShadowRootStyling(n as HTMLElement));
    });
  }
}
